import * as apiLiveUrls from '@/config/api.json';
import * as apiMockUrls from '@/config/api.mock.json';

let apiUrls = apiLiveUrls;

let server = process.env.VUE_APP_API_BASE_URI;

if (process.env.VUE_APP_MOCK) {
    apiUrls = apiMockUrls;
    server = '';
}

/**
 * Get the api routes for an entity.
 *
 * @param {string} path
 * @param {array} replace
 *
 * @return {object}
 */
const entityApiRoutes = (path, replace) => {
    let routes = {};

    Object.entries(apiUrls.default).forEach(([key, item]) => {
        let route = item;

        if (replace) {
            replace.forEach(item => {
                route = route.replace(item.key, item.value);
            });
        }

        if (path && key.startsWith(path + '.')) {
            routes[key.replace(path + '.', '')] = server + route;
        }
    });

    return routes;
};

/**
 * Get the api url with host.
 *
 * @param {string} path
 * @param {object} replace
 *
 * @return {string}
 */
const apiUrl = (path, replace) => {
    let route = apiUrls.default[path];

    if (!replace) {
        return server + route;
    }

    replace.forEach(item => {
        route = route.replace(item.key, item.value);
    });

    return server + route;
};

export { entityApiRoutes, apiUrl };
